module.exports = __webpack_public_path__ + "static/img/6.d9316c0.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/4/1/9/zh/6.png
// module id = Tozf
// module chunks = 0